import './GlobalMessagePortal.scss';

export { default } from './GlobalMessagePortal';
